import * as apiFactory from "./ApiFactory";

import type { Note } from "@/models/Note";

export async function getAllNotes(clientName: string, brand: string, caseReference: string): Promise<Note[]> {
  const client = await apiFactory.WithBearer();
  return client.get<Note[]>(["api/fileEntryNote", clientName, brand, caseReference]);
}

export async function getAllNotesForFile(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
): Promise<Note[]> {
  const client = await apiFactory.WithBearer();
  return client.get<Note[]>(["api/fileEntryNote", clientName, brand, caseReference, fileReference]);
}

export async function saveNote(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  noteRequest: { noteText: string },
): Promise<void> {
  const client = await apiFactory.WithBearer();
  return client.post<{ noteText: string }, void>(
    ["api/fileEntryNote", clientName, brand, caseReference, fileReference],
    noteRequest,
  );
}

export async function deleteNote(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  externalReference: string,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  return client.delete(["api/fileEntryNote", clientName, brand, caseReference, fileReference, externalReference]);
}
